export const SocialAccountConfigurations = {
    "facebook": {
        "post": 10,
        "textLimit": 63206,
        "album": 1000,
        "story": 1,
        "ads": 10,
        "max_image_size_mb": 25,
        "imageDimensions": {
            "post": "1200x630",
            "profilePicture": "170x170",
            "coverPhoto": "820x312"
        },
    },
    "instagram": {
        "post": 10,
        "story": 10,
        "videos": 1,
        "textLimit": 2200,
        "imageDimensions": {
            "square": "1080x1080",
            "portrait": "1080x1350",
            "post": "1080x566",
            "story": "1080x1920"
        },
        "max_image_size_mb": 8,
        "ads": 10
    },
    "twitter": {
        "post": 4,
        "textLimit": 280,
        "imageDimensions": {
            "post": "1200x675",
            "profilePicture": "400x400",
            "coverPhoto": "1500x500"
        },
        "max_image_size_mb": 5,
        "videos": 1
    },
    "linkedin": {
        "post": 9,
        "article": 50,
        "text_limit": 3000,
        "imageDimensions": {
            "post": "1200x627",
            "profilePicture": "400x400",
            "coverPhoto": "1584x396"
        },
        "max_image_size_mb": 5
    },
    "pinterest": {
        "post": 1,
        "textLimit": 500,
        "imageDimensions": {
            "post": "1000x1500",
            "profilePicture": "165x165"
        },
        "max_image_size_mb": 20,
        "carousel": 5
    },
    "tiktok": {
        "post": 1,
        "text_limit": 2200,
        "imageDimensions": {
            "profilePicture": "200x200",
            "video": "1080x1920"
        },
        "max_image_size_mb": 20,
        "videos": 1
    },
    "google": {
        "textLimit": 100000,
        "imageDimensions": {
            "businessProfile": "720x720"
        },
        "post": 10,
        "max_image_size_mb": 5
    },
    "snapchat": {
        "story": 1,
        "textLimit": 80,
        "imageDimensions": {
            "snap": "1080x1920"
        },
        "max_image_size_mb": 5,
        "post": 1
    },
    "youtube": {
        "post": 5,
        "textLimit": 5000,
        "imageDimensions": {
            "post": "1280x720",
            "channel_banner": "2560x1440",
            "profile_picture": "800x800"
        },
        "max_image_size_mb": 2,
        "videos": 1
    }
};
